import { client } from '@/common-utils/libraries/axios/axios';
import { ORGANIZATION } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationDeleteAlertReceivers = (onSuccess, onError) => {
    return {
        mutationFn: ({ organizationId, emails }) => {
            return client.delete(replaceParameters(ORGANIZATION.ALERTS.url, { organizationId: organizationId }), { data: emails });
        },
        onError: (error) => {
            onError(error);
        },
        onSuccess: () => {
            onSuccess();
        },
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationDeleteAlertReceivers;